import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'
import { getUserSessionState } from '../../../selectors/user'

/**
 * Import
 * - Actions
 */
import {
    fecthTrackerActivityTypes,
    fecthPolicyMap,
    fecthQuoteList,
    fecthPoliciesList,
    fetchAgencySummary,
    bindQuoteVariation,
    confirmEditQuote,
} from '../../../actions'

import Dashboard from '../../../components/pages/Dashboard/Dashboard'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        userSession: getUserSessionState(state),
        clientList: state.clientList,
        activityTracker: state.activityTracker,
        policyMap: state.policyMap,
        agencySummary: state.agencySummary,
        step05: state.quote.step05,
    }
}

export default connect(mapStateToProps, {
    fecthTrackerActivityTypes: fecthTrackerActivityTypes,
    fecthPolicyMap: fecthPolicyMap,
    fecthQuoteList: fecthQuoteList,
    fecthPoliciesList: fecthPoliciesList,
    fetchAgencySummary: fetchAgencySummary,
    bindQuoteVariation: bindQuoteVariation,
    confirmEditQuote,
})(Dashboard)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Dashboard/Dashboard.tsx